<template>
    <div>
        <div class="header">Add Feedback</div>

        <form @submit.prevent="onSubmit" class="form response-form" ref="form">
            <div class="reply">
                <div class="reply__buttons">
                    <img ::src="`/images/avatar/${user.id}`" alt="" class="avatar avatar--small">
                </div>
                <fieldset class="reply__fields">
                    <div class="form__group">
                        <textarea v-model="formData.feedback" class="form__control" placeholder="Enter your response here..."></textarea>
                    </div>
                    <div class="form__group">
                        <button class="btn btn--primary">Save</button>
                    </div>
                </fieldset>
            </div>
        </form>
    </div>
</template>

<script>
	import { mapState } from 'vuex';
	import API from '../../../api';
	import FileUpload from '../../Form/FileUpload';

	export default {
		name: 'OpportunityFeedbackForm',
		props: {
			opportunity: {
				type: Number,
				required: true,
			},
		},
		data() {
			return {
				formData: {
					feedback: '',
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.auth.user,
			}),
		},
		methods: {
			onSubmit() {
				API.setOpportunityFeedback(this.opportunity, this.formData).then(response => {
					this.$emit('submitted', response.feedback);
					this.$refs.form.reset();
				});
			},
		}
	}
</script>

<style lang="scss">
    .response-form{
        .form__group{
            button{
                align-self: flex-end;
            }
        }
    }

    .reply{
        display: flex;

        &__buttons{
            width: 4rem;
            flex-grow: 0;
            margin-right: 2rem;

            label{
                width: 100%;
                display: block;
                margin-top: 1rem;

                svg{
                    display: block;
                    margin: 0 auto;
                }
            }
        }

        &__fields{
            flex-grow: 1;
        }
    }
</style>

